<template>
  <div>
    <v-date-picker 
      v-model="date"
      @input="onInput"
      :model-config="dateConfig" 
      mode="date" 
      :first-day-of-week="1" 
      is-range 
      :min-date="minDate"
      :max-date="maxDateValue"
    />

    <br>

    <v-date-picker class="mt-3" :model-config="timeConfig" v-model="time.start" mode="time" @input="onInput" is24hr></v-date-picker>
    
    <br>

    <v-date-picker class="mt-3" :model-config="timeConfig" v-model="time.end" mode="time" @input="onInput" is24hr></v-date-picker>
  </div>
</template>

<script>
export default {
  name: 'Calendar',
  props: ['value', 'minDate', 'maxDate'],
  data () {
    return {
      time: {
        start: '',
        end: '' 
      },
      timeConfig: {
        type: 'string',
        mask: 'HH:mm'
      },
      date: {
        start: '',
        end: '',
      },
      dateConfig: {
        start: {
          type: 'string',
          mask: 'DD/MM/YYYY', 
        },
        end: {
          type: 'string',
          mask: 'DD/MM/YYYY', 
        }
      },
    }
  },
  computed: {
    maxDateValue () {
      return this.maxDate || new Date()
    }
  },
  created () {
    if (this.value.start === '' && this.value.end === '') {
      this.time.start = '00:00'
      this.time.end = '23:59'
      return
    }

    const startParts = this.value.start.split(' ')
    const endParts = this.value.end.split(' ')

    this.date.start = startParts[0]
    this.date.end = endParts[0]
    this.time.start = startParts[1]
    this.time.end = endParts[1]
  },
  methods: {
    onInput () {
      if (this.date.start !== '' && this.date.end !== '') {
        this.$emit('input', {
          start: this.date.start + " " + this.time.start,
          end: this.date.end + " " + this.time.end,
        })
      }
    },
  }
}
</script>

<style>
.vc-date {
  display: none !important;
}
</style>